const screens = {
  small: `(min-width: 576px)`,
  medium: `(min-width: 768px)`,
  large: `(min-width: 992px)`,
  extraLarge: `(min-width: 1200px)`
};

export default screens;
